export const ERROR_CUSTOMER_TYPE = {
  pt: "Não foi possível carregar os tipos de cliente",
  es: "No se pueden cargar tipos de clientes",
  en: "Unable to load client types",
};

export const ERROR_CONTRACTED_PLAN = {
  pt: "Não foi possível carregar os planos contratados",
  es: "No se pueden cargar los planes contratados",
  en: "Unable to load contracted plans",
};

export const ERROR_LOAD_PACK_ICONS = {
  pt: "Não foi possível carregar os pacotes de ícones",
  es: "No fue posible cargar los paquetes de iconos",
  en: "It was not possible to load the icon packages",
};

export const ERROR_LIST_COMPANIES = {
  pt: "Não foi possível carregar a lista de empresas",
  es: "No fue posible cargar la lista de empresas",
  en: "It was not possible to load the company list",
};

export const ERROR_LIST_STATIONS = {
  pt: "Não foi possível carregar a lista de estações",
  es: "No fue posible cargar la lista de estaciones",
  en: "It was not possible to load the station list",
};

export const ERROR_LIST_COUPONS = {
  pt: "Não foi possível carregar a lista de cupons",
  es: "No fue posible cargar la lista de cupones",
  en: "It was not possible to load the coupon list",
};

export const ERROR_LIST_REPORTS = {
  pt: "Não foi possível carregar a lista de relatórios",
  es: "No fue posible cargar la lista de informes",
  en: "It was not possible to load the report list",
};

export const ERROR_LIST_CUSTOM_THEMES = {
  pt: "Não foi possível carregar os temas do CPMS",
  es: "No fue posible cargar los temas de CPMS",
  en: "Unable to load CPMS themes",
};

export const ERROR_LIST_COUNTRIES = {
  pt: "Não foi possível carregar a lista de países",
  es: "No fue posible cargar la lista de países",
  en: "It was not possible to load the country list",
};

export const ERROR_LIST_RECIPIENTS = {
  pt: "Não foi possível carregar a lista de recebedores",
  es: "No fue posible cargar la lista de destinatarios",
  en: "It was not possible to load the recipient list",
};

export const OOPS = {
  pt: "Ops...",
  es: "Epa...",
  en: "Ops...",
};

export const ALL_RIGHT = {
  pt: "Tudo certo!",
  es: "¡Está bien!",
  en: "All set!",
};

export const COMPANY_ADD_SUCCESS = {
  pt: "Empresa adicionada com sucesso!",
  es: "¡Empresa agregada con éxito!",
  en: "Successfully added company!",
};

export const WEN_WONG = {
  pt: "Algo deu errado!",
  es: "¡Algo salió mal!",
  en: "Something went wrong!",
};

export const COMPANIES = {
  pt: "Empresas",
  es: "Empresas",
  en: "Companies",
};

export const ADD_COMPANY = {
  pt: "Adicione uma empresa",
  es: "Agregar una empresa",
  en: "Add a company",
};

export const NAME = {
  pt: "Nome",
  es: "Nombre",
  en: "Name",
};

export const COMPANY_DOCUMENT = {
  pt: "Número ou Identificação",
  es: "Número o Identificación",
  en: "Company document",
};

export const SELECT_DOCUMENT_TYPE = {
  pt: "Selecione o tipo de documento",
  es: "Seleccione el tipo de documento",
  en: "Select document type",
};

export const TYPE_OF_COSTUMER = {
  pt: "Tipo de cliente:",
  es: "Tipo de cliente",
  en: "Type of customer",
};

export const PLACEHOLDER_TYPE_OF_COSTUMER = {
  pt: "Selecione um tipo de cliente",
  es: "Seleccione un tipo de cliente",
  en: "Select a type of customer",
};

export const CONTRACTED_PLAN = {
  pt: "Plano contratado:",
  es: "Plan contratado:",
  en: "Contracted plan:",
};

export const PLACEHOLDER_CONTRACTED_PLAN = {
  pt: "Selecione o plano contratado",
  es: "Selecciona el plan contratado",
  en: "Select the contracted plan",
};

export const MONTHLY_FEE = (currency) => ({
  pt: `mensalidade (${currency}):`,
  es: `Cuota mensual (${currency}):`,
  en: `Monthly fee (${currency}):`,
});

export const NUMBER_CHARGERS = {
  pt: "Quantidade de carregadores:",
  es: "Cantidad de cargadores",
  en: "Number of chargers:",
};

export const TOTAL_MONTHLY_AMOUNT = (currency) => ({
  pt: `Valor total mensal (${currency}):`,
  es: `Total mensual (${currency}):`,
  en: `Total monthly amount (${currency}):`,
});

export const TAX_MODEL = {
  pt: "Modelo fiscal:",
  es: "Modelo fiscal:",
  en: "Tax model:",
};

export const TUPI_RATE = {
  pt: "Taxa Tupi (%):",
  es: "Tarifa Tupi (%):",
  en: "Tupi Rate (%):",
};

export const PLACEHOLDER_TAX_MODEL = {
  pt: "Selecione o modelo fiscal",
  es: "Seleccionar modelo fiscal",
  en: "Select tax model",
};

export const FISCAL_MODEL = {
  pt: "Modelo fiscal Tupi:",
  es: "Modelo fiscal Tupi:",
  en: "Tupi's fiscal model:",
};

export const PLACEHOLDER_FISCAL_MODEL = {
  pt: "Selecione o modelo fiscal",
  es: "Selecciona el modelo fiscal",
  en: "Select the fiscal model",
};

// Warning shown when selecting "Software License" as fiscal model
export const SOFTWARE_LICENSE_WARNING = {
  pt: '"Software License" como modelo fiscal, faz com que as cargas dessa empresa não sejam cobradas do usuário dentro do app e também faz com que suas transações não sejam consideradas como TPV.',
  es: '"Software License" como modelo fiscal, faz com que as cargas dessa empresa não sejam cobradas do usuário dentro do app e também faz com que suas transações não sejam consideradas como TPV.',
  en: '"Software License" as fiscal model makes this company\'s charges not billed by the user\'s app and also makes its transactions not considered as TPV.',
};

export const SOFTWARE_LICENSE_MUTED_HINT = {
  pt: "Não pode ser alterado após a criação da empresa",
  es: "No se puede cambiar después de la creación de la empresa",
  en: "Cannot be changed after company creation",
};

export const PIPEDRIVE_ID = {
  pt: "ID Pipedrive",
  es: "ID Pipedrive",
  en: "Pipedrive ID",
};

export const COUNTRY = {
  pt: "País",
  es: "País",
  en: "Country",
};

export const PHONE = {
  pt: "Telefone",
  es: "Teléfono",
  en: "Phone",
};

export const ADDRESS = {
  pt: "Endereço",
  es: "Dirección",
  en: "Address",
};

export const CITY = {
  pt: "Cidade",
  es: "Ciudad",
  en: "City",
};

export const STATE = {
  pt: "Estado",
  es: "Estado",
  en: "State",
};

export const ZIP_CODE = {
  pt: "CEP",
  es: "Código Postal",
  en: "Zip code",
};

export const ADD = {
  pt: "Adicionar",
  es: "Agregar",
  en: "Add",
};

export const LIST = {
  pt: "Lista",
  es: "Lista",
  en: "List",
};

export const REQUIRED = {
  pt: "Campo obrigatório",
  es: "Campo obligatorio",
  en: "Mandatory field",
};

export const PARENT_COMPANY = {
  pt: "Empresa Mãe",
  es: "Empresa Matriz",
  en: "Parent Company",
};

export const IS_PARENT_COMPANY = {
  pt: "É uma empresa mãe?",
  es: "¿Es una empresa mãe?",
  en: "Is a parent company?",
};

export const SELECT_PARENT_COMPANY = {
  pt: "Selecione a empresa mãe",
  es: "Seleccione la empresa madre",
  en: "Select parent company",
};

export const HAS_PARTNERSHIP = {
  pt: "Possui empresas mãe parceiras?",
  es: "¿Tiene empresas matrices asociadas?",
  en: "Does it have partner parent companies?",
};

export const PARENT_COMPANY_PARTNER = {
  pt: "Empresas mãe parceiras",
  es: "Empresas matrices asociadas",
  en: "Partner parent companies",
};

export const SELECT_PARENT_COMPANY_PARTNER = {
  pt: "Selecione uma ou mais empresas mãe parceiras",
  es: "Seleccione una o más empresas matrices asociadas",
  en: "Select one or more partner parent companies",
};

export const PINS_CUSTOMIZED = {
  pt: "Pin customizado?",
  es: "¿Pin personalizado?",
  en: "Customized pin?",
};

export const COUPON = {
  pt: "Cupons",
  es: "Cupones",
  en: "Coupons",
};

export const STATIONS = {
  pt: "Estações",
  es: "Estaciónes",
  en: "Stacions",
};

export const YES = {
  pt: "Sim",
  es: "Sí",
  en: "Yes",
};

export const NO = {
  pt: "Não",
  es: "No",
  en: "No",
};

export const CHOOSE_PIN = {
  pt: "Escolha o Pin",
  es: "Elija el Pin",
  en: "Choose Pin",
};

export const SELECT = {
  pt: "Selecione",
  en: "Select",
  es: "Seleccionar",
};

export const PATTERN = {
  pt: "Padrão",
  es: "Estándar",
  en: "Default",
};

export const SAVE = {
  pt: "Salvar",
  es: "Guardar",
  en: "Save",
};

export const ACTIONS = {
  pt: "Ações",
  es: "Acciones",
  en: "Actions",
};

export const ADD_MORE = {
  pt: "+ Adicionar",
  es: "+ Añadir",
  en: "+ Add",
};

export const ADMIN = {
  pt: "Admin",
  es: "Admin",
  en: "Admin",
};

export const EMAIL_LIST = {
  pt: "Lista de e-mails",
  es: "Lista de correo electrónico",
  en: "E-mail list",
};

export const EMAIL = {
  pt: "E-mail",
  es: "Correo Electrónico",
  en: "E-mail",
};

export const EMAIL_REPORT_INFO = {
  pt: "Os e-mails nessa lista receberão relatórios mensais com atualizações das estações ",
  es: "Los correos electrónicos de esta lista recibirán informes mensuales con actualizaciones de la estación ",
  en: "Emails on this list will receive monthly reports with station updates ",
};

export const EXAMPLE = {
  pt: "exemplo",
  es: "Ejemplo",
  en: "example",
};

export const EMAIL_REPORT_INFO_TWO = {
  pt: "- consumo de kWh, número de usuários, quantidade e tempo médio de cargas - e a utilização dos cupons ",
  es: "- consumo de kWh, número de usuarios, cantidad y tiempo promedio de cargas - y el uso de los cupones ",
  en: "- kWh consumption, number of users, quantity and average charging time - and the use of coupons ",
};

export const EMAIL_REPORT_INFO_THREE = {
  pt: " incluindo alertas de consumo da cota ",
  es: " incluyendo alertas de consumo del cupón",
  en: " including quota consumption alerts ",
};

export const FINANCIAL = {
  pt: "Financeiro",
  es: "Financiero",
  en: "Financial",
};

export const REPORT = {
  pt: "Relatórios",
  es: "Reporte",
  en: "Report",
};

export const INFORM_VALID_EMAIL = {
  pt: "Informe um e-mail válido",
  es: "Introduzca un correo electrónico válido",
  en: "Inform a valid e-mail",
};

export const INPUT_EMAILS = {
  pt: "Digite os e-mails",
  es: "Escriba los correos electrónicos",
  en: "Type the e-mails",
};

export const INFO = {
  pt: "Informações",
  es: "Información",
  en: "Information",
};

export const CUSTOMIZATION = {
  pt: "Personalização",
  es: "Personalización",
  en: "Customization",
};

export const EMAIL_SUCESS = {
  pt: "Sucesso ao adicionar email",
  es: "Éxito al agregar el correo electrónico",
  en: "Success adding email",
};

export const EMAIL_ERROR = {
  pt: "Erro ao adicionar email",
  es: "Error al agregar el correo electrónico",
  en: "Error adding email",
};

export const REQUIRED_FIELD = {
  pt: "Campo obrigatório",
  es: "Campo obligatorio",
  en: "Mandatory field",
};

export const INVALID_DOCUMENT_FORMAT = {
  pt: "Formato de documento inválido",
  es: "Formato de documento inválido",
  en: "Invalid document format",
};

export const CANCEL = {
  pt: "Cancelar",
  es: "Cancelar",
  en: "Cancel",
};

export const CHARGE_PROCESSING_FEE = {
  pt: "Cobrado de taxas",
  es: "Cobro de tarifas",
  en: "Charged fees",
};

export const CLEAN = {
  pt: "Limpar",
  es: "Limpiar",
  en: "Clear",
};

export const DELETE = {
  pt: "Excluir",
  es: "Eliminar",
  en: "Delete",
};

export const EDIT_COMPANY = {
  pt: "Editar empresa",
  es: "Editar empresa",
  en: "Edit company",
};

// NFSe settings
export const NFSE_SECTION = {
  pt: "NFS-e",
  es: "NFS-e",
  en: "NFS-e",
};

export const NFSE_EMIT = {
  pt: "Enviar dados para emissão de NFS-e em provedor externo",
  es: "Enviar datos para la emisión de NFS-e a un proveedor externo",
  en: "Send data for NFS-e issuance to an external provider",
};

export const NFSE_PROVIDER = {
  pt: "Provedor NFS-e",
  es: "Proveedor NFS-e",
  en: "NFS-e provider",
};

export const NFSE_STATUS_COMPLETED_ACTIVE = {
  pt: "Concluído e Ativo",
  es: "Completado y Activo",
  en: "Completed and Active",
};

export const NFSE_STATUS_PENDING_CONFIGURATION = {
  pt: "Pendente configuração",
  es: "Configuración pendiente",
  en: "Pending configuration",
};

export const NFSE_STATUS_AUTHENTICATED_PENDING = {
  pt: "Autenticado externamente (pendente conclusão)",
  es: "Autenticado externamente (pendiente de finalización)",
  en: "Externally authenticated (pending completion)",
};

export const NFSE_STATUS_LABEL = {
  pt: "Status:",
  es: "Estado:",
  en: "Status:",
};

export const NFSE_REMOVE_INTEGRATION = {
  pt: "Remover Integração",
  es: "Eliminar integración",
  en: "Remove integration",
};

export const NFSE_REMOVE = {
  pt: "Remover",
  es: "Eliminar",
  en: "Remove",
};

export const NFSE_STEP1_AUTHENTICATE = {
  pt: "Autenticar",
  es: "Autenticar",
  en: "Authenticate",
};

export const NFSE_STEP1_AUTHENTICATED = {
  pt: "Autenticado",
  es: "Autenticado",
  en: "Authenticated",
};

export const NFSE_STEP2_COMPLETE = {
  pt: "Concluir",
  es: "Completar",
  en: "Complete",
};

export const NFSE_FILL_CLIENT_ID = {
  pt: "Preencha o Client ID para autenticar",
  es: "Complete el Client ID para autenticar",
  en: "Fill in the Client ID to authenticate",
};

export const NFSE_FILL_CLIENT_SECRET = {
  pt: "Preencha o Client Secret para autenticar",
  es: "Complete el Client Secret para autenticar",
  en: "Fill in the Client Secret to authenticate",
};

export const NFSE_FILL_PROVIDER_LOGIN = {
  pt: "Preencha e-mail e senha para continuar",
  es: "Complete el correo y la contraseña para continuar",
  en: "Fill in email and password to continue",
};

export const NFSE_AUTH_INFO_TITLE = {
  pt: "Autenticação Conta Azul",
  es: "Autenticación Conta Azul",
  en: "Conta Azul authentication",
};

export const NFSE_AUTH_INFO_TEXT = {
  pt: "Você será redirecionado para o ambiente Conta Azul para concluir a autenticação externa.",
  es: "Será redirigido al entorno de Conta Azul para completar la autenticación externa.",
  en: "You will be redirected to Conta Azul to complete external authentication.",
};

export const NFSE_AUTH_INFO_CONTINUE = {
  pt: "Entendi, continuar processo",
  es: "Entendido, continuar proceso",
  en: "Got it, continue process",
};

export const NFSE_PROVIDER_LOGIN_TITLE = {
  pt: "Login do Provedor (Simulação)",
  es: "Inicio de sesión del proveedor (simulación)",
  en: "Provider login (simulation)",
};

export const NFSE_PROVIDER_LOGIN_EMAIL = {
  pt: "E-mail",
  es: "Correo electrónico",
  en: "Email",
};

export const NFSE_PROVIDER_LOGIN_PASSWORD = {
  pt: "Senha",
  es: "Contraseña",
  en: "Password",
};

export const NFSE_PROVIDER_LOGIN_SUBMIT = {
  pt: "Entrar",
  es: "Entrar",
  en: "Sign in",
};

export const NFSE_INTEGRATION_COMPLETED = {
  pt: "Integração NFS-e concluída com sucesso",
  es: "Integración NFS-e completada con éxito",
  en: "NFS-e integration completed successfully",
};

export const NFSE_CLIENT_ID = {
  pt: "Client ID",
  es: "Client ID",
  en: "Client ID",
};

export const NFSE_CLIENT_SECRET = {
  pt: "Client Secret",
  es: "Client Secret",
  en: "Client Secret",
};

export const NFSE_GENERATE_AUTH_LINK = {
  pt: "Gerar link de autenticação",
  es: "Generar enlace de autenticación",
  en: "Generate authentication link",
};

export const NFSE_AUTHENTICATE_NOW = {
  pt: "Autenticar agora",
  es: "Autenticar ahora",
  en: "Authenticate now",
};

export const NFSE_AUTH_LINK_READY = {
  pt: "Link de autenticação pronto",
  es: "Enlace de autenticación listo",
  en: "Authentication link ready",
};

export const ERROR_GENERATE_AUTH_LINK = {
  pt: "Não foi possível gerar o link de autenticação",
  es: "No fue posible generar el enlace de autenticación",
  en: "Could not generate authentication link",
};

export const ERROR_LOAD_WHITELABEL_LIST = {
  pt: "Não foi possível carregar a lista de white labels",
  es: "No fue posible cargar la lista de white Labels",
  en: "It was not possible to load the white labels list",
};

export const FILTER = {
  pt: "Filtrar",
  es: "Filtrar",
  en: "Filter",
};

export const LIABLE = {
  pt: "Risco de chargeback",
  es: "Riesgo de contracargo",
  en: "Chargeback risk",
};

export const MANAGEMENT = {
  pt: "Administração",
  es: "Administración",
  en: "Administration",
};

export const NEW = {
  pt: "Nova",
  es: "Nueva",
  en: "New",
};

export const PAYMENT_SPLIT_RULE = {
  pt: "Regra de split de pagamentos",
  es: "Regla de división de pagos",
  en: "Payment split rule",
};

export const PERCENTAGE = {
  pt: "percentage",
  es: "porcentaje",
  en: "percentage",
};

export const RECIPIENT = {
  pt: "Recebedor",
  es: "Receptor",
  en: "Recipient",
};

export const SEARCH = {
  pt: "Pesquisar",
  es: "Buscar",
  en: "Search",
};

export const SEARCH_BY_COMPANY = {
  pt: "Pesquise pela empresa...",
  es: "Busque por la empresa...",
  en: "Search by company...",
};

export const SELECT_RECIPIENT = {
  pt: "Selecione um recebedor",
  es: "Seleccione un receptor",
  en: "Select a recipient",
};

export const SELECT_STATION = {
  pt: "Selecione a estação",
  es: "Seleccione la estación",
  en: "Select a station",
};

export const SELECT_STATUS = {
  pt: "Selecione o status",
  es: "Seleccione el estado",
  en: "Select status",
};

export const SELECT_TYPE = {
  pt: "Selecione o tipo",
  es: "Seleccione el tipo",
  en: "Select type",
};

export const SELECT_WHITELABEL = {
  pt: "Selecione o white label",
  es: "Seleccione la etiqueta blanca",
  en: "Select the white label",
};

export const SELECT_APPS_TITLE = {
  pt: "Selecione os apps",
  es: "Seleccione las apps",
  en: "Select the apps",
};

export const SHOW_DETAILS_EDIT = {
  pt: "Ver detalhes | Editar",
  es: "Ver detalles | Editar",
  en: "See details | Edit",
};

export const TOTAL = {
  pt: "Total",
  es: "Total",
  en: "Total",
};

export const TOTAL_NOT_FULL = {
  pt: "Total não chegou a 100%",
  es: "El total no alcanzó el 100%",
  en: "Total did not reach 100%",
};

export const URL_POWERBI = {
  pt: "Url PowerBI",
  es: "Url PowerBI",
  en: "Url PowerBI",
};

export const USER = {
  pt: "Usuário",
  es: "Usuario",
  en: "User",
};

export const WHITE_LABEL = {
  pt: "White Label",
  es: "Etiqueta blanca",
  en: "White Label",
};

export const CPMS_CUSTOM_THEME = {
  pt: "Tema CPMS",
  es: "Tema CPMS",
  en: "CPMS theme",
};

export const SELECT_CPMS_CUSTOM_THEME = {
  pt: "Selecione um tema CPMS",
  es: "Seleccione un tema CPMS",
  en: "Select a CPMS theme",
};

export const OCPI_PARTY_ID = {
  pt: "ID de parceiro OCPI (party_id)",
  es: "OCPI Party ID",
  en: "OCPI Party ID",
};

export const ALLOWED_APPS_LABEL = {
  pt: "Apps permitidos",
  es: "Apps permitidas",
  en: "Allowed apps",
};

export const ALLOWED_APPS_DESCRIPTION = {
  pt: "Apps em que as estações podem ser utilizadas: visualizar no mapa e iniciar carga",
  es: "Apps donde las estaciones pueden ser utilizadas: ver en el mapa e iniciar carga",
  en: "Apps where the stations can be used: view on the map and start charging",
};

export const COMPANY_CUSTOM_ALLOWED_APPS_NOTICE = {
  pt: "Esta empresa está utilizando uma configuração própria de apps permitidos, independentemente da configuração da empresa mãe",
  es: "Esta empresa está utilizando una configuración propia de apps permitidas, independientemente de la configuración de la empresa matriz",
  en: "This company is using its own allowed apps configuration, regardless of the parent company’s configuration",
};

export const PARENT_ALLOWED_APPS_NOTICE = {
  pt: "As estações desta empresa estão permitidas nos apps abaixo conforme a configuração herdada da empresa mãe",
  es: "Las estaciones de esta empresa están permitidas en las apps de abajo según la configuración heredada de la empresa matriz",
  en: "The stations of this company are allowed in the apps below according to the configuration inherited from the parent company",
};

export const CUSTOM_ALLOWED_APPS_INSTRUCTION = {
  pt: "Se você deseja definir uma configuração própria para esta empresa (sem considerar a configuração da empresa mãe), selecione os apps específicos no campo abaixo:",
  es: "Si desea definir una configuración propia para esta empresa (sin considerar la configuración de la empresa matriz), seleccione las apps específicas en el campo de abajo:",
  en: "If you want to define a custom configuration for this company (without considering the parent company’s configuration), select the specific apps in the field below:",
};

export const THE_APP_LABEL = {
  pt: "O app",
  es: "La app",
  en: "The app",
};

export const IS_REQUIRED_LABEL = {
  pt: "é obrigatório",
  es: "es obligatorio",
  en: "is required",
};

export const THE_PARENT_COMPANY = {
  pt: "A empresa mãe",
  es: "La empresa matriz",
  en: "The parent company",
};

export const PARENT_COMPANY_HAS_CUSTOM_PIN = {
  pt: `já possui o "Pin customizado"`,
  es: `ya tiene el "Pin personalizado"`,
  en: `already has the "Customized pin"`,
};

export const PARENT_COMPANY_HAS_CUSTOM_PIN_2 = {
  pt: "Você pode manter esta configuração ou editar abaixo.",
  es: "Puede mantener esta configuración o editar a continuación.",
  en: "You can keep this configuration or edit below.",
};

export const CONTA_AZUL_REDIRECT_URL_TITLE = {
  pt: "URL de redirecionamento",
  es: "URL de redirección",
  en: "Redirect URL",
};

export const CONTA_AZUL_REDIRECT_URL_DESC_PREFIX = {
  pt: "O dashboard da Conta Azul solicita uma URL de redirecionamento,",
  es: "El panel de Conta Azul solicita una URL de redirección,",
  en: "The Conta Azul dashboard requires a redirect URL,",
};

export const CONTA_AZUL_REDIRECT_URL_DESC_SUFFIX = {
  pt: "para copiar.",
  es: "para copiar.",
  en: "to copy.",
};

export const COPY = {
  pt: "Copiar",
  es: "Copiar",
  en: "Copy",
};

export const COPIED = {
  pt: "Copiado",
  es: "Copiado",
  en: "Copied",
};

export const CLICK_HERE = {
  pt: "clique aqui",
  es: "haga clic aquí",
  en: "click here",
};

export const ONLY_DRAFTS_LABEL = {
  pt: "Empresas rascunho",
  es: "Empresas borrador",
  en: "Draft companies",
};

export const ONLY_DRAFTS_ON = {
  pt: "Somente rascunhos",
  es: "Solo borradores",
  en: "Drafts only",
};

export const ONLY_DRAFTS_OFF = {
  pt: "Todas as empresas",
  es: "Todas las empresas",
  en: "All companies",
};

export const ACTIVATE_COMPANY = {
  pt: "Ativar empresa",
  es: "Activar empresa",
  en: "Activate company",
};

export const ACTIVATE_COMPANY_SUCCESS = {
  pt: "Empresa ativada com sucesso!",
  es: "¡Empresa activada con éxito!",
  en: "Company successfully activated!",
};

export const ERROR_ACTIVATE_COMPANY = {
  pt: "Não foi possível ativar a empresa. Tente novamente.",
  es: "No fue posible activar la empresa. Inténtelo de nuevo.",
  en: "Could not activate the company. Please try again.",
};

export const ACTIVATE_COMPANY_CONFIRM = {
  pt: "Confirmar ativação desta empresa?",
  es: "¿Confirmar activación de esta empresa?",
  en: "Confirm activation of this company?",
};

export const BATCH_DURATION_TYPE = {
  pt: "Tipo de repasse:",
  es: "Tipo de transferencia:",
  en: "Payout type:",
};

export const PLACEHOLDER_BATCH_DURATION_TYPE = {
  pt: "Selecione o tipo de repasse",
  es: "Selecciona el tipo de transferencia",
  en: "Select the payout type",
};

export const BATCH_DURATION_TYPE_DAILY = { pt: "Diário", es: "Diario", en: "Daily" };
export const BATCH_DURATION_TYPE_WEEKLY = { pt: "Semanal", es: "Semanal", en: "Weekly" };
export const BATCH_DURATION_TYPE_BIWEEKLY = { pt: "Quinzenal", es: "Quincenal", en: "Biweekly" };
export const BATCH_DURATION_TYPE_MONTHLY = { pt: "Mensal", es: "Mensual", en: "Monthly" };

export const IDLE_FEE_FIRST_FORGIVENESS_LABEL = {
  pt: "Isentar primeira taxa de ociosidade",
  es: "Eximir primera tarifa de inactividad",
  en: "Waive first idle fee",
};

export const IDLE_FEE_FIRST_FORGIVENESS_DESCRIPTION = {
  pt: "Quando ativado, a primeira cobrança de taxa de ociosidade do usuário é perdoada automaticamente",
  es: "Cuando está activado, el primer cobro de tarifa de inactividad del usuario se perdona automáticamente",
  en: "When enabled, the user's first idle fee charge is automatically waived",
};

export const IDLE_FEE_FIRST_FORGIVENESS_INHERITED = {
  pt: "Habilitado via empresa mãe. Para alterar, edite a configuração na empresa mãe.",
  es: "Habilitado a través de la empresa madre. Para cambiar, edite la configuración en la empresa madre.",
  en: "Enabled via parent company. To change, edit the configuration in the parent company.",
};

export const WEB_FLOW_GATEWAY_LABEL = {
  pt: "Habilitar opção de recarga pelo navegador",
  es: "Habilitar opción de recarga por el navegador",
  en: "Enable browser charging option",
};

export const WEB_FLOW_GATEWAY_DESCRIPTION = {
  pt: "Ao habilitar esta opção, quando um novo usuário ler o QR Code, ele terá opção entre baixar o aplicativo ou iniciar a recarga pelo navegador",
  es: "Al habilitar esta opción, cuando un nuevo usuario lea el código QR, tendrá la opción de descargar la aplicación o iniciar la recarga por el navegador",
  en: "When this option is enabled, a new user who scans the QR Code will be able to choose between downloading the app or starting the charge in the browser",
};

export const WEB_FLOW_GATEWAY_BATCH_NOTE = {
  pt: "Alterar aplica em lote nas estações desta empresa e das empresas filhas. Este seletor não reflete a configuração já salva nas estações.",
  es: "Cambiar aplica en lote a las estaciones de esta empresa y de las empresas filiales. Este selector no refleja la configuración ya guardada en las estaciones.",
  en: "Changing this applies in batch to the stations of this company and its subsidiaries. This switch does not reflect the configuration already saved on the stations.",
};

export const WEB_FLOW_GATEWAY_AFFECTED_STATIONS = {
  pt: "estações desta empresa e das empresas filhas serão alteradas.",
  es: "estaciones de esta empresa y de las empresas filiales serán modificadas.",
  en: "stations in this company and its subsidiaries will be changed.",
};

export const WEB_FLOW_GATEWAY_CONFIRM = {
  pt: "Isso altera o QR code delas. Deseja continuar?",
  es: "Esto modifica su código QR. ¿Desea continuar?",
  en: "This changes their QR code. Do you want to continue?",
};

export const WEB_FLOW_GATEWAY_SUCCESS = {
  pt: "estações atualizadas.",
  es: "estaciones actualizadas.",
  en: "stations updated.",
};

export const WEB_FLOW_GATEWAY_PARTIAL_TITLE = {
  pt: "Alteração parcial",
  es: "Cambio parcial",
  en: "Partial change",
};

export const WEB_FLOW_GATEWAY_PARTIAL = {
  pt:
    "estações foram alteradas e continuam assim. As demais não mudaram. Países já aplicados:",
  es:
    "estaciones fueron modificadas y siguen así. Las demás no cambiaron. Países ya aplicados:",
  en:
    "stations were changed and stay that way. The rest were not changed. Countries already applied:",
};

export const WEB_FLOW_GATEWAY_NO_STATIONS = {
  pt: "Esta empresa não tem estações com QR code para atualizar.",
  es: "Esta empresa no tiene estaciones con código QR para actualizar.",
  en: "This company has no stations with a QR code to update.",
};

export const WEB_FLOW_GATEWAY_ERROR = {
  pt: "Não foi possível atualizar as estações.",
  es: "No se pudieron actualizar las estaciones.",
  en: "Could not update the stations.",
};
